// Instance
export const AUTH_INSTANCE = "/auth-service";
export const MIDDLE_INSTANCE = "/middle-service";
export const MIDDLE_V2_INSTANCE = "/middle-service-v2";
export const TRANSACTION_INSTANCE = "/transaction-service";
export const PUBLISH_INSTANCE = "/publish-service";
export const DIRECT_INSTANCE = "/direct-service";
export const SYNC_INSTANCE = "/scheduler-service";
export const SYNC_V2_INSTANCE = "/scheduler-service-v2";
export const SYNC_V3_INSTANCE = "/scheduler-service-v3";

// Extentions //

// End Point //
// Auth
export const AUTH_ME = `auth/me`;
export const AUTH_LOGIN = `auth/login`;
export const AUTH_REGISTER = `auth/register`;
export const RESET_PASSWORD = `auth/reset-password`;
export const CHANGE_PASSWORD = `auth/me/change-password`;
export const CHANGE_PASSWORD_EXTERNAL = `change-password-external`;
export const PASSWORD_VALIDATE_EXTERNAL = `password-validate`;
export const LOGIN = `login`;
export const LOGOUT = `logout`;
export const REFRESH_TOKEN = `refresh-token`;

// Branch
export const BRANCH = `branch`;
export const BRANCH_SEQ = `${BRANCH}/branch-card-seq`;
export const BRANCH_CODE = `${BRANCH}/branch-code`;
export const BRANCH_BY_USER_LOGIN = `${BRANCH}/by-user-login`;
export const BRANCH_LIST = `${BRANCH}/list-branch`;
export const BRANCH_RATE = `${BRANCH}/branchRate`;
export const BRANCH_RATE_LIST = `${BRANCH}/list-branchRate`;
export const BRANCH_RATE_MULTIPLE = `${BRANCH}/multiple-branchRate`;
export const BRANCH_RATE_IMPORT = `${BRANCH}/import-branchRate`;
export const BRANCH_IMPORT_MASS_UPDATE = `${BRANCH}/import-massUpdate`;
export const BRANCH_RATE_EXPORT = `${BRANCH}/export-rate`;
export const BRANCH_RATE_CONFIRM = `${BRANCH}/confirm-branchRate`;
export const BRANCH_MASS_CONFIRM = `${BRANCH}/confirm-massUpdate`;
export const BRANCH_FEE = `${BRANCH}/branchFee`;
export const BRANCH_FEE_LIST = `${BRANCH}/list-branchFee`;
export const BRANCH_LIST_EXCLUSIVE_STORE = `${BRANCH}/list-exclusiveStore`;
export const BRANCH_ADD_EXCLUSIVE_STORE = `${BRANCH}/addExclusiveStore`;
export const BRANCH_EDIT_EXCLUSIVE_STORE = `${BRANCH}/editExclusiveStore`;
export const BRANCH_UPDATE_EXCLUSIVE_STORE = `${BRANCH}/updateExclusiveStore`;
export const BRANCH_DELETE_EXCLUSIVE_STORE = `${BRANCH}/deleteExclusiveStore`;
export const BRANCH_RATE_ADD_EXCLUSIVE_STORE = `${BRANCH}/add-exclusive-rate`;
export const BRANCH_RATE_EXCLUSIVE_STORE = `${BRANCH}/exclusive-rate`;
export const BRANCH_RATE_MIN_RATE = `${BRANCH}/rate`;
export const BRANCH_RATE_DEFAULT = `${BRANCH}/reset-branch-rate`;

// Branch CMS
export const BRANCH_CMS = `branch-cms`;

// Role
export const ROLE = `roles`;
export const ROLE_LIST = `${ROLE}/list`;
export const ROLE_INSERT = `${ROLE}/insert-user-role`;
export const ROLE_INSERT_RESTRICTION_EXPORT = `${ROLE}/insert-role-restriction-export`;

// User
export const USER = `user`;
export const USER_STATUS = `${USER}/status`;
export const USER_VALIDATE_USERNAME = `${USER}/validate-username`;
export const USER_VALIDATE_EMAIL = `${USER}/validate-email`;
export const USER_CURRENT = `${USER}/current`;
export const USER_CHANGE_PASSWORD = `${USER}/change-password`;
export const USER_LOV = `${USER}/lov`;
export const USER_LOV_MRA = `${USER}/lov/mra`;
export const USER_LOV_USER_MRO = `${USER}/lov/user-mro`;
export const USER_LOV_MRO = `${USER}/user-mro`;
export const USER_SF = `${USER}/list-users`;
export const USER_BY_ROLE = `${USER}/list-users-by-role`;
export const USER_ACTIVATE = `${USER}/activate`;
export const USER_DEACTIVATE = `${USER}/deactivate`;
export const USER_ACTIVATE_ALL = `${USER}/activate-all`;
export const USER_DEACTIVATE_ALL = `${USER}/deactivate-all`;
export const USER_SAVE_AGREEMENT = `${USER}/save-agreement`;
export const MEMBER_MANAGEMENT = `member-management`;
export const RESEND_EMAIL_VERIFICATION = `${MEMBER_MANAGEMENT}/resend-email-verification`;
export const UPDATE_VERIFIED_EMAIL = `${MEMBER_MANAGEMENT}/update-verify-email`;
export const MEMBER_UPDATE_PASSWORD = `${MEMBER_MANAGEMENT}/reset-password`;
export const EXPORT_MEMBER_MANAGEMENT = `${MEMBER_MANAGEMENT}/export`;

// Member
export const MEMBER = `member`;
export const MEMBER_STATUS = `${MEMBER}/status`;
export const MEMBER_CARD_NUMBERING = `${MEMBER}/numbering-card`;
export const MEMBER_EXPORT = `${MEMBER}/export`;
export const MEMBER_DATABASE_TYPE = `${MEMBER}/database-type`;
export const MEMBER_PROGRAM_TYPE = `${MEMBER}/program-type`;
export const MEMBER_ADVANCE_SEARCH = `${MEMBER}/advance-search`;
export const MEMBER_SYNC = `${MEMBER}/sync-member`;
export const MEMBER_SYNC_MULTI = `${MEMBER}/sync-member-multi`;
export const MEMBER_DEACTIVE = `${MEMBER}/active-deactivate`;
export const MEMBER_CARD_REASON = `${MEMBER}/card-reset-reason`;
export const MEMBER_RISK_PROFILE = `${MEMBER}/risk-profile`;
export const MEMBER_RISK_PROFILE_BROWSE = `${MEMBER}/risk-profile-browse`;
export const MEMBER_RISK_PROFILE_EXPORT = `${MEMBER}/risk-profile-export`;
export const MEMBER_EXPORT_REFERRAL_CODE = `${MEMBER}/exportReferralCode`;
export const MEMBER_ESCROW = `escrow-member`;
export const MEMBER_ESCROW_DETAIL = `${MEMBER}/escrow-detail`;
export const MEMBER_ESCROW_STATUS = `${MEMBER}/escrow-status`;
export const MEMBER_ESCROW_UPDATE = `${MEMBER}/escrow-update`;
export const MEMBER_ESCROW_BALANCE = `${MEMBER}/escrow-balance-tracking`;
export const MEMBER_FAQ_SETUP = `${MEMBER}/faq`;
export const MEMBER_PHOTOS_POOLING = `${MEMBER}/list-image`;
export const MEMBER_SYNC_BY_CUSTNO = `${MEMBER}/sync-member`;

// Member Group
export const MEMBER_GROUP = `member-group`;
export const MEMBER_GROUP_LIST = `${MEMBER_GROUP}/list`;

// Member Employee
export const MEMBER_EMPLOYEE = `employee`;

// Blacklist Phone Number
export const BLACKLIST_PHONE_NO = `phone-blacklist`;
export const BLACKLIST_PHONE_NO_IMPORT = `${BLACKLIST_PHONE_NO}/import-phone-blacklist`;
export const BLACKLIST_PHONE_NO_CONFIRM = `${BLACKLIST_PHONE_NO}/confirm-import`;
export const BLACKLIST_PHONE_NO_DELETE_MULTIPLE = `${BLACKLIST_PHONE_NO}/multiple`;

// External Source
export const EXTERNAL_SOURCE = `external-source`;
export const EXTERNAL_SOURCE_ADV = `${EXTERNAL_SOURCE}/advance-search`;
export const EXTERNAL_SOURCE_LOV = `external-source/lov`;

// Import Member
export const IMPORT_MEMBER = `import-member`;
export const IMPORT_MEMBER_DETAIL = `${IMPORT_MEMBER}/detail`;
export const IMPORT_MEMBER_DOWNLOAD = `${IMPORT_MEMBER}/download`;
export const IMPORT_MEMBER_LOGERROR = `${IMPORT_MEMBER}/getLogError`;
export const IMPORT_MEMBER_STOP = `${IMPORT_MEMBER}/stop`;
export const IMPORT_MEMBER_STATUS = `${IMPORT_MEMBER}/getStatus`;
export const IMPORT_MEMBER_LOG_FILE = `${IMPORT_MEMBER}/log`;
export const IMPORT_MEMBER_CANCEL = `${IMPORT_MEMBER}/cancel`;

export const IMPORT_MEMBER_EMPLOYEE_IMPORT = `employee/import`;
export const IMPORT_MEMBER_EMPLOYEE_LIST = `${IMPORT_MEMBER_EMPLOYEE_IMPORT}/list`;
export const IMPORT_MEMBER_EMPLOYEE_CANCEL = `${IMPORT_MEMBER_EMPLOYEE_IMPORT}/cancel`;

// Password Policy
export const PASSWORD_POLICY = `password-policy`;
export const PASSWORD_POLICY_VALIDATE = `${PASSWORD_POLICY}/validate`;

// Menu
export const MENU = `menu`;
export const MENU_SUBMENU = `${MENU}/submenu`;
export const MENU_RESTRICTION_EXPORT = `${MENU}/restriction-export`;

// Home
export const HOME = `home`;
export const HOME_STORE = `${HOME}/store`;
export const HOME_TRX_STORE = `${HOME}/store-trx`;
export const HOME_TRX_STORE_DOWNLOAD = `${HOME}/download-storeTrx`;

// Permission
export const PERMISSION_MENU = `permission/menu`;
export const PERMISSION_SUBMENU = `permission/submenu`;

// Transaction
export const TRANSACTION = `transaction`;

// PO Status
export const PO_STATUS = `${TRANSACTION}/browse`;
export const PO_STATUS_ADV = `${TRANSACTION}/advance-search`;
export const PO_STATUS_DETAIL = `${TRANSACTION}/detail`;
export const DOWNLOAD_PO = `${TRANSACTION}/download-po`;
export const PO_STATUS_LIST = `${TRANSACTION}/list-status`;
export const PO_SOURCE_LIST = `${TRANSACTION}/list-source`;
export const CUSTOMER_TYPE_LIST = `${TRANSACTION}/lov-customer-type`;
export const STORE_SECURE_ID = `${TRANSACTION}/store/getSecureId`;
export const MEMBER_SECURE_ID = `${TRANSACTION}/member/getSecureId`;
export const SEND_PO = `${TRANSACTION}/send-po`;
export const SEND_COPY_CONTRACT = `${TRANSACTION}/send-copy-contract`;
export const EXPORT_PO_STATUS = `${TRANSACTION}/export`;
export const PHOTOS_POOLING = `${TRANSACTION}/list-image`;
export const RETRY_ORDER_FULL = `${TRANSACTION}/update-orderful`;

// Order Archive
export const ORDER_ARCHIVE = `order-archive`;

// PO Status Archive
export const PO_STATUS_ARCHIVE = `${ORDER_ARCHIVE}`;
export const PO_STATUS_ARCHIVE_DETAIL = `${ORDER_ARCHIVE}`;
export const DOWNLOAD_PO_ARCHIVE = `${ORDER_ARCHIVE}/download-po`;
export const EXPORT_PO_STATUS_ARCHIVE = `${ORDER_ARCHIVE}/export`;
export const PO_STATUS_ARCHIVE_RESTORE = `${ORDER_ARCHIVE}/restore`;
export const PO_STATUS_ARCHIVE_RESTORE_ALL = `${ORDER_ARCHIVE}/restore-all`;

// Order Archive NMC
export const ORDER_ARCHIVE_NMC = `order-archive-nmc`;

// PO Status Archive
export const PO_STATUS_NMC_ARCHIVE = `${ORDER_ARCHIVE_NMC}`;
export const PO_STATUS_NMC_ARCHIVE_DETAIL = `${ORDER_ARCHIVE_NMC}`;
export const DOWNLOAD_PO_NMC_ARCHIVE = `${ORDER_ARCHIVE_NMC}/download-po`;
export const EXPORT_PO_STATUS_NMC_ARCHIVE = `${ORDER_ARCHIVE_NMC}/export`;
export const PO_STATUS_NMC_ARCHIVE_RESTORE = `${ORDER_ARCHIVE_NMC}/restore`;
export const PO_STATUS_NMC_ARCHIVE_RESTORE_ALL = `${ORDER_ARCHIVE_NMC}/restore-all`;

// Card Issuance
export const ISSUANCE = `issuance`;
export const ISSUANCE_CANCEL = `${ISSUANCE}/cancel-issuance`;
export const CARD_LIST = `${ISSUANCE}/card-list`;
export const CARD_LIST_DETAIL = `${ISSUANCE}/detail-card-list`;
export const DELIVERY_LIST = `${ISSUANCE}/detail-delivery-list`;
export const DELIVERY_LIST_DETAIL = `${ISSUANCE}/delivery-list-detail`;
export const DOWNLOAD_FILE = `${ISSUANCE}/download`;
export const PRINT_DOWNLOAD = `${ISSUANCE}/print-issuance`;
export const UPLOAD_RECEIPT = `${ISSUANCE}/upload-receipt`;
export const UPLOAD_DELIVER = `${ISSUANCE}/import-inssuance-delivery-customer`;
export const SYNC_BRANCH = `${ISSUANCE}/sync-branch`;
export const CONFIRM_DELIVER_CUSTOMER = `${ISSUANCE}/confirm-inssuance-delivery-customer`;
export const DELIVER_BRANCH = `${ISSUANCE}/deliver-branch`;

// Card No Generator
export const GENERATOR = `card-no-generator`;
export const GENERATOR_IMPORT = `${GENERATOR}/import`;
export const GENERATOR_CONFIRM_CUSTOMER = `${GENERATOR}/confirm-customer`;
export const GENERATOR_CONFIRM_BRANCH = `${GENERATOR}/confirm-branch`;

//  E-Card Printing
export const ECARD = `ecard-printing`;
export const ECARD_LIST = `${ECARD}`;
export const ECARD_AVAILABLE = `${ECARD}/available-card`;
export const ECARD_DETAIL = `${ECARD}/card`;
export const ECARD_CONFIRM_BRANCH = `${ECARD}/confirm-deliver-branch`;
export const ECARD_DELIVER_BRANCH = `${ECARD}/deliver-branch`;
export const ECARD_DELIVER_CUSTOMER = `${ECARD}/deliver-customer`;
export const ECARD_DELIVER_IMPORT_CUSTOMER = `${ECARD}/import`;
export const ECARD_CONFIRM_CUSTOMER = `${ECARD}/confirm-deliver-customer`;

// Card No Reservation
export const RESERVATION = `card-reserve`;
export const RESERVATION_LIST = `${RESERVATION}`;
export const RESERVATION_DETAIL = `${RESERVATION}/detail-by-seq`;
export const RESERVATION_DETAIL_EDIT = `${RESERVATION}/detail`;
export const RESERVATION_IMPORT = `${RESERVATION}/import`;
export const RESERVATION_CONFIRM = `${RESERVATION}/confirm`;
export const SEARCH_BY_BRANCH = `${RESERVATION}/searchby-branch`;
export const RESERVATION_DELIVER_BRANCH = `${RESERVATION}/deliver-branch`;
export const RESERVATION_DELIVER_CUSTOMER = `${RESERVATION}/confirm-deliver-customer`;
export const RESERVATION_CONFIRM_BRANCH = `${RESERVATION}/confirm-deliver-branch`;
export const SEARCH_BY_SEQUENCE = `${RESERVATION}/searchby-seq`;
export const SEQUENCE_DETAIL = `${RESERVATION}/detail-by-seq`;
export const RESERVATION_DELIVER_CUSTOMER_SEQ = `${RESERVATION_DELIVER_CUSTOMER}-seq`;
export const RESERVATION_DELIVER_BRANCH_SEQ = `${RESERVATION_DELIVER_BRANCH}-seq`;

// Card Tracking
export const CARD_TRACKING = `card-tracking`;
export const CARD_TRACKING_LIST = `${CARD_TRACKING}/list`;
export const CARD_TRACKING_EXPORT = `${CARD_TRACKING}/export`;
export const CARD_TRACKING_ADV_SEARCH = `${CARD_TRACKING}/advSearch`;
export const CARD_TRACKING_DETAIL = `detail-card-list-detail`;

// Card Assignment
export const CARD_ASSIGNMENT = `card-assignment`;
export const CARD_ASSIGNMENT_LIST = `${CARD_ASSIGNMENT}`;
export const CARD_ASSIGNMENT_CARD_LIST = `${CARD_ASSIGNMENT}/detail-card-list`;
export const CARD_ASSIGNMENT_DETAIL_INFO = `${CARD_ASSIGNMENT}/detail-info`;
export const CARD_ASSIGNMENT_CARD_LIST_DETAIL = `${CARD_ASSIGNMENT}/detail-view-card`;
export const CARD_ASSIGNMENT_RETURN_TO_BRANCH = `${CARD_ASSIGNMENT}/return-to-branch`;
export const CARD_ASSIGNMENT_DELIVERY_DOC = `${CARD_ASSIGNMENT}/delivery-document`;
export const CARD_ASSIGNMENT_SEARCH_CARD = `${CARD_ASSIGNMENT}/search-card`;
export const CARD_ASSIGNMENT_AVAILABLE_MEMBER = `${CARD_ASSIGNMENT}/count-available-member-card`;
export const CARD_ASSIGNMENT_CREATE_AUTO = `${CARD_ASSIGNMENT}/create-auto`;
export const CARD_ASSIGNMENT_CONFIRM_AUTO = `${CARD_ASSIGNMENT}/confirm-create-auto`;
export const CARD_ASSIGNMENT_CREATE_MANUAL = `${CARD_ASSIGNMENT}/create-manual`;
export const CARD_ASSIGNMENT_CONFIRM_CREATE_MANUAL = `${CARD_ASSIGNMENT}/confirm-create-manual`;
export const CARD_ASSIGNMENT_SELECT_FOR_ECARD = `${CARD_ASSIGNMENT}/select-for-assignment`;
export const CARD_ASSIGNMENT_AVAILABLE_ECARD = `${CARD_ASSIGNMENT}/available-eCard`;
export const CARD_ASSIGNMENT_CREATE_ECARD = `${CARD_ASSIGNMENT}/create-eCard-assignment`;
export const CARD_ASSIGNMENT_CONFIRM_ECARD = `${CARD_ASSIGNMENT}/confirm-create-eCard-assignment`;
export const CARD_ASSIGNMENT_DOWNLOAD_COVER_LETTER = `${CARD_ASSIGNMENT}/download-cover-letter`;
export const CARD_ASSIGNMENT_VALIDATE = `${CARD_ASSIGNMENT}/validate-add-for-assignment`;

// Card Pickup
export const CARD_PICKUP = `card-pickup`;
export const CARD_PICKUP_CREATE_MANUAL = `${CARD_PICKUP}/manual`;
export const CARD_PICKUP_CREATE_MANUAL_CONFIRM = `${CARD_PICKUP}/confirm-manual`;
export const CARD_PICKUP_CREATE_DIGITAL_TO_PRINT_CONFIRM = `${CARD_PICKUP}/confirm-printing`;
export const CARD_PICKUP_CREATE_DIGITAL_TO_PRINT = `${CARD_PICKUP}/ecard`;
export const CARD_PICKUP_DETAIL = `${CARD_PICKUP}/card`;
export const CARD_PICKUP_DOWNLOAD = `${CARD_PICKUP}/download`;
export const CARD_PICKUP_UPLOAD = `${CARD_PICKUP}/uploadImage`;

// Card Verification
export const CARD_VERIFICATION = `card-verification`;
export const CARD_VERIFICATION_DETAIL_INFO = `${CARD_VERIFICATION}/detail-info`;
export const CARD_VERIFICATION_DETAIL_CARD_LIST = `${CARD_VERIFICATION}/detail-card-list`;
export const CARD_VERIFICATION_CARD_LOV = `${CARD_VERIFICATION}/card-list-lov`;
export const CARD_VERIFICATION_DOWNLOAD_CARD_LIST = `${CARD_VERIFICATION}/download-cardList`;
export const CARD_VERIFICATION_MANUAL_SAVE = `${CARD_VERIFICATION}/manual-save`;
export const CARD_VERIFICATION_MANUAL_CONFIRM = `${CARD_VERIFICATION}/manual-confirm`;
export const CARD_VERIFICATION_REISSUE = `${CARD_VERIFICATION}/reissue`;
export const CARD_VERIFICATION_LIST = `${CARD_VERIFICATION}/verification-list`;
export const CARD_VERIFICATION_IMPORT_MANUAL = `${CARD_VERIFICATION}/import-manual-check`;

// Card Lost
export const CARD_LOST = `card-lost`;
export const CARD_LOST_DETAIL = `${CARD_LOST}/card`;
export const CARD_LOST_MRA = `${CARD_LOST}/add-mra`;
export const CARD_LOST_MRO = `${CARD_LOST}/add-mro`;
export const CARD_LOST_FORM_MRA = `${CARD_LOST}/form-add-mra`;

// Card Distribution
export const CARD_DISTRIBUTION = `card-distribution`;
export const CARD_DISTRIBUTION_EXPORT = `${CARD_DISTRIBUTION}/export`;

// Lost Reason
export const LOST_REASON = `lost-reason`;

// Card Stock
export const CARD_STOCK = `card-stock`;

// Delivery Return Reason
export const RETURN_REASON = `return-reason`;
export const DELIVERY_RETURN_REASON = `delivery-${RETURN_REASON}`;
export const DELIVERY_RETURN_REASON_DETAIL = `delivery-${RETURN_REASON}/detail-deliveryReturnReason`;
export const DELIVERY_RETURN_REASON_LOV = `delivery-${RETURN_REASON}/lov`;

// Verification Return Reason
export const VERIFICATION_RETURN_REASON = `verification-${RETURN_REASON}`;
export const VERIFICATION_RETURN_REASON_DETAIL = `verification-${RETURN_REASON}/detail-verificationReturnReason`;
// Card Source
export const CARD_SOURCE = `card-source`;

// Card Type
export const CARD_TYPE = `card-type`;

// Zip Code
export const ZIP_CODE = `zip-code`;
export const ZIP_CODE_LOV = `${ZIP_CODE}/lov`;
export const ZIP_CODE_IMPORT = `${ZIP_CODE}/import-zipcode`;
export const ZIP_CODE_IMPORT_CONFIRM = `${ZIP_CODE}/import-confirm`;

// MRA
export const MRA = `mra`;
export const MRA_BY_USERLOGIN = `${MRA}/by-user-login`;
export const MRA_BROWSE = `${MRA}/browse`;
export const MRA_DETAIL = `${MRA}/detail`;
export const MRA_BRANCH = `${MRA}/branch-by-mra`;

// MRO
export const MRO = `mro`;
export const MRO_BY_USERLOGIN = `${MRO}/by-user-login`;

// PROMO
export const PROMO = `promo`;
export const PROMO_LOV = `${PROMO}/list-promo`;
export const PROMO_UPLOAD = `${PROMO}/import`;
export const PROMO_SYNC = `uvp/promo`;
export const PROMO_SYNC_FIFAPPS = `fifApps/get-promo`;
export const PROMO_RATE_UPLOAD = `${PROMO}/import-promoRate`;
export const PROMO_RATE_CONFIRM = `confirm-promoRate`;
export const PROMO_RATE_DETAIL = `detailPromoRate`;
export const PROMO_RATE_UPDATE = `${PROMO}/updatePromoRate`;
export const PROMO_RATE_DEFAULT = `${PROMO}/reset-promo-rate`;
export const PROMO_IMPORT_UPDATE_BULK = `${PROMO}/import-update-bulk`;
export const PROMO_CONFIRM_UPDATE_BULK = `${PROMO}/confirm-update-bulk`;

// STORE
export const STORE = `store`;
export const STORE_ACTIVATED = `${STORE}/activated`;
export const STORE_DEACTIVATED = `${STORE}/deactivated`;
export const STORE_GROUP = `storeGroup`;
export const STORE_GROUP_LOV = `${STORE_GROUP}/lov`;
export const STORE_EXPORT = `${STORE}/export`;
export const STORE_SYNC = `${STORE}/sync-store`;
export const STORE_MAPPING_SF_LIST = `${STORE}/list-storeSf`;
export const STORE_IMPORT_SF = `${STORE}/import-sf`;
export const STORE_SF_CONFIRM = `${STORE}/add-storesf`;
export const STORE_SF_DELETE = `${STORE}/delete-storeSf`;
export const STORE_LIST_BY_BRANCH = `${STORE}/list-storebyBranch`;
export const STORE_MS = `${STORE}/store-ms`;

// EXCLUSIVE STORE RATE

export const EXCLUSIVE_STORE_RATE = `exclusive-store-rate`;
export const EXCLUSIVE_STORE_RATE_DETAIL = `${EXCLUSIVE_STORE_RATE}/detail`;
export const EXCLUSIVE_STORE_RATE_IMPORT = `${EXCLUSIVE_STORE_RATE}/import-store-exclusive-rate`;
export const EXCLUSIVE_STORE_RATE_CONFIRM_IMPORT = `${EXCLUSIVE_STORE_RATE}/confirm-import-store-exclusive-rate`;

// PRODUCT
export const PRODUCT = `product`;
export const PRODUCT_SYNC = `${PRODUCT}/sync`;
export const PRODUCT_LOV_PRODUCT_GROUP = `${PRODUCT}/lov-product-group`;
export const PRODUCT_GROUP = `product-group`;
export const PRODUCT_GROUP_UPLOAD = `${PRODUCT_GROUP}/upload`;
export const PRODUCT_INSURANCE = `${PRODUCT}/insurance`;
export const PRODUCT_INSURANCE_DETAIL = `${PRODUCT_INSURANCE}/detil`;
export const PRODUCT_INSURANCE_SYNC = `fifApps/insurance-product`;
export const PRODUCT_INSURANCE_SYNC_VALID = `fifApps/sync-valid-until-insurance-product`;
export const PRODUCT_INSURANCE_MPF = `insurance-mpf`;
export const PRODUCT_INSURANCE_MPF_DETAIL = `${PRODUCT_INSURANCE_MPF}/detail`;

// PRODUCT NMC
export const PRODUCT_NMC = `product-nmc`;
export const PRODUCT_NMC_SYNC = `fifApps/master-product-nmc`;
export const PRODUCT_NMC_LOV_PRODUCT_GROUP = `${PRODUCT}/lov-product-group`;
export const PRODUCT_NMC_INSURANCE = `product-insurance-nmc`;
export const PRODUCT_NMC_INSURANCE_DETAIL = `${PRODUCT_INSURANCE}/detil`;
export const PRODUCT_NMC_INSURANCE_SYNC = `fifApps/insurance-product`;

// PRODUCT GROUP NMC
export const PRODUCT_GROUP_NMC = "product-group-nmc";
export const PRODUCT_GROUP_NMC_DETAIL = "product-group-nmc/detail";
export const PRODUCT_GROUP_NMC_UPLOAD = `${PRODUCT_GROUP_NMC}/upload`;
export const PRODUCT_GROUP_NMC_LOV = `${PRODUCT_GROUP_NMC}/lov-product-group`;

// PROMO NMC
export const PROMO_NMC = `promo-nmc`;
export const PROMO_NMC_LOV = `${PROMO_NMC}/list-promo`;
export const PROMO_NMC_DEFAULT = `${PROMO_NMC}/reset-promo-rate-nmc`;

// BRANCH NMC
export const BRANCH_NMC = `branch-nmc`;
export const BRANCH_NMC_DEFAULT = `${BRANCH_NMC}/reset-branchRate`;

// BRANCH UFI
export const BRANCH_UFI = `branch-refi`;
export const BRANCH_UFI_DEFAULT = `${BRANCH_UFI}/reset-branchRate`;

// KIOSK UFI
export const KIOSK_UFI = `kios-refi`;
export const KIOSK_UFI_CREATE = `${KIOSK_UFI}/add-new`;
export const KIOSK_UFI_SYNC = `fifApps/master-kiosk`;

// QANUN BRANCH
export const QANUN_BRANCH = `branch-form`;
export const QANUN_BRANCH_IMPORT = `${QANUN_BRANCH}/import-branchForm`;
export const QANUN_BRANCH_IMPORT_UPDATE = `${QANUN_BRANCH}/update-import-branchForm`;
export const QANUN_BRANCH_IMPORT_CONFIRM = `${QANUN_BRANCH}/confirm-import-branchForm`;

// BRANCH PROMO
export const BRANCH_PROMO = `branch-promo`;
export const BRANCH_PROMO_PROMO_FEE = `${BRANCH_PROMO}/promo-fee`;
export const BRANCH_PROMO_ADMIN_MURNI = `${BRANCH_PROMO}/admin-murni`;
export const BRANCH_PROMO_PROMO_FEE_LIST = `${BRANCH_PROMO}/list-promo-fee`;
export const BRANCH_PROMO_ADMIN_MURNI_LIST = `${BRANCH_PROMO}/list-admin-murni`;
export const BRANCH_PROMO_PROMO_FEE_RESET = `${BRANCH_PROMO}/reset-promo-fee`;
export const BRANCH_PROMO_ADMIN_MURNI_RESET = `${BRANCH_PROMO}/reset-admin-fee`;
export const BRANCH_PROMO_COMPANY_LIST = `${BRANCH_PROMO}/list-company`;
export const BRANCH_PROMO_PLATFORM_LIST = `${BRANCH_PROMO}/list-platform`;
export const BRANCH_PROMO_TOP_RANGE_LIST = `${BRANCH_PROMO}/list-top-range`;
export const BRANCH_PROMO_IMPORT_MASS_UPDATE = `${BRANCH_PROMO}/import-admin-promo-fee`;
export const BRANCH_PROMO_IMPORT_MASS_CONFIRM = `${BRANCH_PROMO}/confirm-admin-promo-fee`;

// Financial Scheme
export const FINANCIAL_SCHEME = `financial-scheme`;
export const FINANCIAL_SCHEME_MSCODE = `${FINANCIAL_SCHEME}/msCode`;
export const FINANCIAL_SCHEME_BRANCH = `${FINANCIAL_SCHEME}/list-branch`;

// Financial Scheme NMC
export const FINANCIAL_SCHEME_NMC = `financial-scheme-nmc`;
export const FINANCIAL_SCHEME_MSCODE_NMC = `${FINANCIAL_SCHEME_NMC}/msCode`;
export const FINANCIAL_SCHEME_BRANCH_NMC = `${FINANCIAL_SCHEME_NMC}/list-branch`;

// PO Status NMC
export const TRANSACTION_NMC = `transaction-nmc`;
export const PO_STATUS_NMC = `${TRANSACTION_NMC}`;
export const EXPORT_PO_STATUS_NMC = `${TRANSACTION_NMC}/export`;
export const STORE_NMC_SECURE_ID = `${TRANSACTION_NMC}/store/getSecureId`;
export const MEMBER_NMC_SECURE_ID = `${TRANSACTION}/member/getSecureId`;
export const SEND_PO_NMC = `${TRANSACTION_NMC}/send-po`;
export const SEND_COPY_CONTRACT_NMC = `${TRANSACTION_NMC}/send-copy-contract`;
export const DOWNLOAD_PO_NMC = `${TRANSACTION_NMC}/download-po-nmc`;
export const PHOTOS_POOLING_NMC = `${TRANSACTION_NMC}/list-image`;

// Replace Card Number
export const REPLACE_CARD_NUMBER = `replace-card`;
export const REPLACE_CARD_NUMBER_SUBMIT = `${REPLACE_CARD_NUMBER}/submit`;
export const REPLACE_CARD_NUMBER_VERIFICATION = `${REPLACE_CARD_NUMBER}/verification`;

// Membership Silo
export const MEMBERSHIP_SILO = `member-import-silo`;

// Database Type Setup
export const DATABASE_TYPE_SETUP = `database-type`;

// Card Reset Reason
export const CARD_RESET_REASON = `card-reset-reason`;

// Reason for Update
export const REASON_FOR_UPDATE = `/reason-for-update`;

// Reason for Loss
export const REASON_FOR_LOSS = `/lost-reason`;

// Program Type
export const PROGRAM_TYPE = "/program-type";
export const PROGRAM_TYPE_UPLOAD = `${PROGRAM_TYPE}/import`;

// Company
export const COMPANY = `company`;
export const COMPANY_SYNC_FIFAPPS = `/fifApps/company-branch`;

// Company
export const REGION = `regional`;

// Order
export const ORDER = `order-log`;

// Notification Error
export const NOTIFICATION_ERROR = `message-notification`;

export const BANNER = `/banner`;

// App Setting Properties
export const SETTING_PROPERTIES = `/app-properties`;

// NMC
export const NMC_STORE = `/nmcStore`;
export const NMC_PROMO = `/promo-nmc`;
export const NMC_MASTER_INSURANCE = `/insurance-nmc`;
export const PROMO_NMC_SYNC_FIFAPPS = `/fifApps/get-promo-nmc`;
export const DEALER_NMC_SYNC_FIFAPPS = `/fifApps/master-store`;
export const RESET_NMC_STORE = `${NMC_STORE}/reset-store`;
export const NMC_MARKETING_SCHEME = `${NMC_STORE}/edit-marketing-scheme`;
export const NMC_ADMIN_FEE = `${NMC_STORE}/edit-admin-fee`;
export const NMC_PROMO_FEE = `${NMC_STORE}/edit-promo-fee`;
export const NMC_PROMO_FEE_LIST = `${NMC_STORE}/list-promo-fee-rule`;
export const NMC_ADMIN_FEE_LIST = `${NMC_STORE}/list-admin-fee-rule`;
export const NMC_DEALER_PGC_ID_SYNC = `/fifApps/sync-master-ms126-fifapps`;

// UFI
export const UFI_STORE = `/refiStore`;
export const UFI_PROMO = `promo-refi`;
export const UFI_PROMO_SYNC_FIFAPPS = `/fifApps/refi/promo`;
export const UFI_PROMO_RESET = `${UFI_PROMO}/reset-promo-rate-refi`;

// PRODUCT REFI
export const PRODUCT_REFI = `product-refi`;
export const PRODUCT_REFI_SYNC = `fifApps/master-product-refi`;
export const PRODUCT_REFI_LOV_PRODUCT_GROUP = `${PRODUCT}/lov-product-group`;
export const PRODUCT_REFI_INSURANCE = `product-insurance-refi`;
export const PRODUCT_REFI_INSURANCE_DETAIL = `${PRODUCT_INSURANCE}/detil`;
export const PRODUCT_REFI_INSURANCE_SYNC = `fifApps/insurance-product`;

// PRODUCT GROUP REFI
export const PRODUCT_GROUP_REFI = "product-group-refi";
export const PRODUCT_GROUP_REFI_DETAIL = "product-group-refi/detail";
export const PRODUCT_GROUP_REFI_UPLOAD = `${PRODUCT_GROUP_REFI}/upload`;
export const PRODUCT_GROUP_REFI_LOV = `${PRODUCT_GROUP_REFI}/lov-product-group`;

// PROMO REFI
export const PROMO_REFI = `promo-refi`;
export const PROMO_REFI_LOV = `${PROMO_REFI}/list-promo`;
export const PROMO_REFI_DEFAULT = `${PROMO_REFI}/reset-promo-rate-refi`;

// Exclusive Dealer Admin NMC
export const EXCLUSIVE_DEALER_ADMIN_NMC = `/nmc-exclusive-dealer-admin`;
export const EXCLUSIVE_DEALER_ADMIN_NMC_IMPORT = `/nmc-exclusive-dealer-admin/import-update-bulk`;
export const EXCLUSIVE_DEALER_ADMIN_NMC_IMPORT_CONFIRM = `/nmc-exclusive-dealer-admin/confirm-update-bulk`;
export const EXCLUSIVE_DEALER_ADMIN_NMC_PGC_ID = `/nmc-exclusive-dealer-admin/lov-pgc`;
export const EXCLUSIVE_DEALER_ADMIN_NMC_SYNC = `/fifApps/sync-master-ms126-fifapps`;

// Exclusive Dealer Admin NMC
export const EXCLUSIVE_DEALER_RATE_NMC = `/nmc-dealer-exclusive-rate`;
export const EXCLUSIVE_DEALER_RATE_NMC_IMPORT = `/nmc-dealer-exclusive-rate/import-update-bulk`;
export const EXCLUSIVE_DEALER_RATE_NMC_IMPORT_CONFIRM = `/nmc-dealer-exclusive-rate/confirm-update-bulk`;

// Tiering Plafond
export const TIERING = `/tier`;

// Audit Trail
export const AUDIT_TRAIL = `audit-trail`;

// Transaction Error Log
export const TRANSACTION_LOG = `transaction-log`;
export const TRANSACTION_LOG_TYPES = `${TRANSACTION_LOG}/types`;
export const TRANSACTION_LOG_COUNT_CHANNEL = `${TRANSACTION_LOG}/count-channel`;
export const TRANSACTION_LOG_COUNT_TYPE = `${TRANSACTION_LOG}/count-type`;

// Transaction Reject Log
export const TRANSACTION_REJECT_LOG = `reject-underwriting-log`;
export const TRANSACTION_REJECT_LOG_EXPORT = `${TRANSACTION_REJECT_LOG}/export`;

// Transaction Error Log
export const TRANSACTION_ERROR_LOG = `transaction-log-error`;

// Transaction Error Log
export const ORDERFULL_LOG = `order-full-log`;

// Master LOB
export const MASTER_LOB = `master-lob/name`;

// OTP Log
export const OTP_LOG = `otp`;
export const OTP_LOG_STATUS = `${OTP_LOG}/status`;

// Message Log
export const MESSAGE_LOG = `notification`;

// Scheduler Log
export const SCHEDULER_LOG = `scheduler-log`;

// Message Log
export const MEMBER_LOG = `checking-plafond-log`;

// Exit Log
export const EXIT_LOG = `exit-log`;
export const LOV_EXIT_PAGE = `${EXIT_LOG}/lov-exit-page`;
export const LIST_EXIT_REASON = `list-exit-reason`;

// Balance Tracking Log
export const BALANCE_TRACKING_LOG = `balance-tracking`;

// Master Token API
export const MASTER_TOKEN = `auth-client`;

// Master LOB API
const master_lob = "master-lob";
export const MASTER_LOB_LIST = {
  LIST: `${master_lob}/list`,
  DETAIL: `${master_lob}/detail`,
  UPDATE: `${master_lob}`
};

// SMS Content
const sms_content = "sms-content";
export const SMS_CONTENT = {
  LIST: `${sms_content}/list`,
  DETAIL: `${sms_content}`,
  UPDATE: `${sms_content}`,
  PARAMETER: `${sms_content}/get-parameter`
};

// Custonmer Confirmation
const customer_confirmation = "customer_consent";
export const CUSTOMER_CONFIRMATION = {
  ROOT: `${customer_confirmation}`,
  STEP: `${customer_confirmation}/step`,
  STEPS: `${customer_confirmation}/steps`,
  TITLE: `${customer_confirmation}/title`,
  UPLOAD_FILE: `${customer_confirmation}/upload`,
  HISTORY: `${customer_confirmation}/history`,
  ACTIVATE: `${customer_confirmation}/active`,
  PARAMETER: `${customer_confirmation}/parameter`
};

// Download Management
const download_management = "download-report-management";
export const DOWNLOAD_MANAGEMENT = {
  ROOT: `${download_management}`,
  CANCEL: `${TRANSACTION}/cancel-export`,
  RELAUNCH: `${TRANSACTION}/relaunch-export`,
  LIST_TYPE: `${download_management}/lov-report-type`
};

// Customer Satisfaction Survey
const customer_satisfaction_survey = "survey";
export const CUSTOMER_SURVEY = {
  ROOT: `${customer_satisfaction_survey}`,
  LIST_TAGS: "list-master-tags",
  EXPORT: `${customer_satisfaction_survey}/export`
};

// Master Insurance
export const INSURANCE_MPF = "insurance-mpf";

// Extended
export const EXTENDED = {
  ORDER_HISTORY: `order-history`,
  DETAIL_MEMBER_DOCUMENT: `detail-member-document`,
  UPLOAD_DOCUMENT: `upload-document`
};

// Mediator
export const LIST_SAO = "sao/list-member";
export const ASSIGN_MEMBER_TO_MEDIATOR = "sao/assign";
export const list_mediator = "activation-mediator";
export const MEDIATOR = {
  LIST: `${list_mediator}`,
  REJECT: `${list_mediator}/reject`,
  ACCEPT: `${list_mediator}/accept`,
  PROMO: `${list_mediator}/promo-agent`,
  PRODUCT: `${list_mediator}/product-promo`,
  SUBMIT_PRE_ORDER: `${list_mediator}/insert-task-list`
};
export const SAO_LIST_MEDIATOR = "sao/list-mediator";

export const MENU_MANAGEMENT = "menu";
export const SUB_MENU_MANAGEMENT = `${MENU_MANAGEMENT}/submenu`;

export const REASONS_FOR_EXTENSION = `reason-for-extended-activation`;

// Family Financing
export const FAMILY_FINANCING = "family-finance";

// Add this to your existing constants
export const PUBLISH = {
  PURPOSE: "purpose"
};
